export default {
    sentences:[],
    sentence:{},
}
